exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-3!./assets/css/index.css"), "");

// module
exports.push([module.id, "*{margin:0;padding:0}@media screen and (min-width:1025px){.skytop{height:80px}.skyapp{height:120px}}@media screen and (max-width:1024px){.skytop{height:2.2rem}.skyapp{height:9.05rem}}", ""]);

// exports
